// CommentsSummary.tsx
import React from 'react';
import { PCARCommentInfo} from './DataReview.interfaces';
import styled from 'styled-components';

interface CommentsSummaryProps {
  data: PCARCommentInfo[];
}

const SummaryContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const TotalComments = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

const CommentsSummary: React.FC<CommentsSummaryProps> = ({ data }) => {
  const totalComments = data.length;


  return (
    <SummaryContainer>
      <TotalComments>(Summary) Total Comments: {totalComments}</TotalComments>
    </SummaryContainer>
  );
};

export default CommentsSummary;